<template>
    <div v-if="transaction.payments.length" class="">
        <div v-if="getSuccessfulPayment(transaction.payments)">
            <div
                class="title px-1 mx-0 my-2 pb-0 font-weight-medium text-success"
            >
                Payment
            </div>

            <div
                style="border: 1px solid #5cb860; border-radius: 10px; cursor: pointer;"
                class="pa-2 mt-2 mb-3"
                @click="
                    expandPayment(
                        getSuccessfulPayment(transaction.payments),
                        transaction,
                    )
                "
            >
                <v-layout row class="mb-1 mx-1 pt-3">
                    <v-icon
                        class="mx-3"
                        dark
                        style="font-size: 20px;"
                        :color="
                            getPaymentStatusIconColor(
                                getSuccessfulPayment(transaction.payments),
                            )
                        "
                        >{{
                            getPaymentStatusIcon(
                                getSuccessfulPayment(transaction.payments),
                            )
                        }}</v-icon
                    >
                    <div class="font-weight-regular">
                        <span class="font-weight-medium">Date:</span><br />
                        {{
                            getSuccessfulPayment(transaction.payments).date
                                | time
                        }}
                    </div>
                    <v-spacer></v-spacer>
                    <div class="font-weight-regular">
                        <span class="font-weight-medium">Card:</span><br />
                        {{
                            (getSuccessfulPayment(transaction.payments).cardType
                                ? getSuccessfulPayment(transaction.payments)
                                      .cardType
                                : "") +
                                " - " +
                                (getSuccessfulPayment(transaction.payments)
                                    .cardNumLast5
                                    ? getSuccessfulPayment(transaction.payments)
                                          .cardNumLast5
                                    : "")
                        }}
                    </div>
                    <v-spacer></v-spacer>
                    <div class="mr-3 font-weight-regular">
                        <span class="font-weight-medium">Status:</span><br />
                        {{
                            getSuccessfulPayment(transaction.payments)
                                .statusValue
                        }}
                    </div>
                </v-layout>

                <div v-if="getSuccessfulPayment(transaction.payments).expanded">
                    <v-divider></v-divider>
                    <div class="pa-2 my-2">
                        <v-layout
                            row
                            class="px-3 py-1"
                            v-for="prop in getPaymentProperties(
                                getSuccessfulPayment(transaction.payments),
                            )"
                        >
                            <div class="font-weight-medium mr-2">
                                {{ prop.name }}:
                            </div>
                            <div>
                                {{ prop.value }}
                            </div>
                        </v-layout>
                    </div>
                </div>
            </div>
        </div>

        <div
            v-if="getFailedPayments(transaction.payments).length"
            class="title px-1 mx-0 my-2 pb-0 font-weight-medium text-danger"
        >
            {{ getFailedPaymentsTitle(transaction.payments) }}
        </div>

        <div
            v-for="payment in getFailedPayments(transaction.payments)"
            style="border: 1px solid #f44336; border-radius: 10px; cursor: pointer;"
            class="pa-2 my-2"
            @click="expandPayment(payment, transaction)"
        >
            <v-layout row class="mb-1 mx-1 pt-3">
                <v-icon
                    class="mx-3"
                    dark
                    style="font-size: 20px;"
                    :color="getPaymentStatusIconColor(payment)"
                    >{{ getPaymentStatusIcon(payment) }}</v-icon
                >
                <div class="font-weight-regular">
                    <span class="font-weight-medium">Date:</span><br />
                    {{ payment.date | time }}
                </div>
                <v-spacer></v-spacer>
                <div class="font-weight-regular">
                    <span class="font-weight-medium">Card:</span><br />
                    {{ payment.cardType + " - " + payment.cardNumLast5 }}
                </div>
                <v-spacer></v-spacer>
                <div class="mr-3 font-weight-regular">
                    <span class="font-weight-medium">Status:</span><br />
                    {{ payment.statusValue }}
                </div>
            </v-layout>

            <div v-if="payment.expanded">
                <v-divider></v-divider>
                <div class="pa-2 my-2">
                    <v-layout
                        row
                        class="px-3 py-1"
                        v-for="prop in getPaymentProperties(payment)"
                    >
                        <div class="font-weight-medium mr-2">
                            {{ prop.name }}:
                        </div>
                        <div>
                            {{ prop.value }}
                        </div>
                    </v-layout>
                </div>
            </div>
        </div>
    </div>

    <!-- <div
        v-if="
            transaction.schedules.length
        "
        class=""
    >
        <div
            class="title px-1 pt-3 mx-0 mt-2 pb-0 font-weight-medium"
        >
            {{
                getSchedulesTitle(
                    transaction.schedules,
                    transaction,
                )
            }}
        </div>

        <div
            v-for="schedule in transaction.schedules"
            style="border: 1px solid rgb(253, 180, 0) !important; border-radius: 10px; cursor: pointer;"
            class="pa-2 my-2"
            @click="
                expandSchedule(
                    schedule,
                    transaction,
                )
            "
        >
            <v-layout
                row
                class="mb-1 mx-1 pt-3"
            >
                <v-icon
                    class="mx-3"
                    dark
                    style="font-size: 20px;"
                    :color="
                        getScheduleStatusIconColor(
                            schedule,
                        )
                    "
                    >{{
                        getScheduleStatusIcon(
                            schedule,
                        )
                    }}</v-icon
                >
                <div
                    class="font-weight-regular"
                >
                    <span
                        class="font-weight-medium"
                        >Schedule
                        Date:</span
                    ><br />
                    {{
                        schedule.scheduleDate
                            | time
                    }}
                </div>
                <v-spacer></v-spacer>
                <div
                    class="font-weight-regular"
                >
                    <span
                        class="font-weight-medium"
                        >Card:</span
                    ><br />
                    {{
                        schedule.cardType +
                            " - " +
                            schedule.cardNumLast5
                    }}
                </div>
                <v-spacer></v-spacer>
                <div
                    class="mr-3 font-weight-regular"
                >
                    <span
                        class="font-weight-medium"
                        >Enabled:</span
                    ><br />
                    <span
                        v-bind:class="{
                            'text-danger': !schedule.isEnabled,
                        }"
                        >{{
                            schedule.isEnabled
                                ? "Yes"
                                : "No"
                        }}</span
                    >
                </div>
                <v-spacer></v-spacer>
                <div
                    class="mr-3 font-weight-regular"
                >
                    <span
                        class="font-weight-medium"
                        >Schedule
                        Status:</span
                    ><br />
                    {{
                        schedule.status
                    }}
                </div>
            </v-layout>

            <div
                v-if="schedule.expanded"
            >
                <v-divider></v-divider>
                <div class="pa-2 my-2">
                    <v-layout
                        row
                        class="px-3 py-1"
                        v-for="prop in getScheduleProperties(
                            schedule,
                        )"
                    >
                        <div
                            class="font-weight-medium mr-2"
                        >
                            {{
                                prop.name
                            }}:
                        </div>
                        <div>
                            {{
                                prop.value
                            }}
                        </div>
                    </v-layout>
                </div>
            </div>
        </div>
    </div> -->
</template>
<script>
import moment from "moment";
import {
    getDomain,
    except,
    toTitleCase,
    truncate,
} from "../../utils/helpers.js";

export default {
    props: {
        transaction: Object,
    },
    data() {
        return {};
    },
    async created() {},
    methods: {
        getPaymentsTitle(payments) {
            return payments.length == 1
                ? "Payment"
                : "Payments (" + payments.length + ")";
        },
        getSuccessfulPayment(payments) {
            return payments.find((p) => p.status == "PROCESSED");
        },
        getFailedPayments(payments) {
            return payments.filter((p) => p.status != "PROCESSED");
        },
        getFailedPaymentsTitle(payments) {
            return this.getFailedPayments(payments).length == 1
                ? "Failed Payment"
                : "Failed Payments (" + payments.length + ")";
        },
        getPaymentStatusIcon(payment) {
            switch (payment.statusValue.toUpperCase()) {
                case "PROCESSED":
                    return "mdi-check-circle";
                case "DECLINED":
                    return "mdi-alert";
                case "ERROR":
                    return "mdi-alert-circle";
                case "SCHEDULED":
                    return "mdi-clock";
                default:
                    return "";
            }
        },
        getPaymentStatusIconColor(payment) {
            switch (payment.statusValue.toUpperCase()) {
                case "PROCESSED":
                    return "success";
                case "DECLINED":
                case "ERROR":
                    return "#f35123";
                case "SCHEDULED":
                    return "#fdb400";
                default:
                    return "#aeb8bf";
            }
        },
        expandPayment(payment, transaction) {
            if (!payment) return;

            payment.expanded = !payment.expanded;

            transaction.payments
                .filter((p) => p.paymentID != payment.paymentID)
                .forEach((p) => {
                    p.expanded = false;
                });

            this.$forceUpdate();
        },
        hasSchedule(schedules) {
            return schedules.length;
        },
        getScheduleDate(schedules) {
            if (!this.hasSchedule(schedules)) return;

            return schedules[0].scheduleDate;
        },
        getEnabledStatus(schedules) {
            if (!this.hasSchedule(schedules)) return;

            return schedules[0].isEnabled ? "Yes" : "No";
        },
        getPaymentProperties(payment) {
            if (!payment) return;

            return Object.keys(
                except(
                    payment,
                    "accountID",
                    "name",
                    "amount",
                    "paymentType",
                    "status",
                    "statusIcon",
                    "source",
                    "scheduleDetailID",
                    "scheduleID",
                    "paymentMethodID",
                    "expanded",
                ),
            )
                .map((key) => {
                    return {
                        name: toTitleCase(key),
                        value: payment[key],
                    };
                })
                .filter((p) => p.value);
        },
    },
};
</script>
